import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
//icons
import { ShoppingCartRounded as ShoppingCartRoundedIcon, ReceiptRounded as ReceiptRoundedIcon, GroupsRounded as GroupsRoundedIcon, Home as HomeIcon, Person as PersonIcon, Apartment as ApartmentIcon, LocationOn as LocationOnIcon, } from "@mui/icons-material";
//Redux Functinality
import { useSelector } from "react-redux";
import CartShare from "../CartShare/CartSharing";
import CustomerDetails from "../CustomerInvoice/CustomerDetails";
import Dashboard from "../DashboardLayout/Dashboard";
import DiscountCoupon from "../DiscountCoupon/DiscountCoupon";
import MyCustomer from "../MyCustomer/MyCustomer";
import SalesOrderDetails from "../SalesOrderDetails/SalesOrderDetails";
import Teams from "../TeamsLayout/Teams";
import AffiliateLinkContactCard from "../AffiliateLinkContactCard/AffiliateLinkContactCard";
import { ContactAndAffiliteLinkIcon, DiscountCouponIcon, b2bIcon, cartSharingIcon } from "../../assets/Images/images";
import B2bCustomerDetails from "../CreateB2BOrder/B2BCustomerDetails/B2BCustomerDetails";
import MyCompany from "../MyCompany/MyCompany";
import TerritoryReports from "../TerritoryReports/TerritoryReports";
export default function Tabs() {
    var _a;
    var t = useTranslation().t;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var selectFeature = salesRepData.baseData.select ? salesRepData.baseData.select : {};
    var additionaiFeatureB2BCompany = ((_a = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _a === void 0 ? void 0 : _a.showB2BMyCompany) ? true : false;
    var repData = salesRepData.baseData;
    var isTeamManager = (repData && repData.SingleSalesRep && repData.SingleSalesRep.RepType) === "SalesManager" ? true : false;
    return [
        // {
        //   isActive: true,
        //   icon: <DashboardRounded />,
        //   label: t("tab_Dashboard"),
        // },
        // {
        //   isActive: !selectFeature.CustomerInvoice && !selectFeature.ClientDiscount && !selectFeature.CommissionPerRep ? false : true,
        //   icon: <ShoppingCartRounded />,
        //   label: t("tab_CustomerInvoice"),
        // },
        // {
        //   isActive: !selectFeature.AffiliateLink && !selectFeature.AffiliateLinkCommissionPerRep ? false : true,
        //   icon: <ConnectWithoutContactRounded />,
        //   label: t("tab_AffiliateLink"),
        // },
        // {
        //   isActive: selectFeature.CartSharing ? true : false,
        //   icon: <ShoppingCartCheckoutRounded />,
        //   label: t("tab_CartSharing"),
        // },
        // {
        //   isActive: selectFeature.CouponeCode ? true : false,
        //   icon: <DiscountRounded />,
        //   label: t("tab_DiscountCoupon"),
        // },
        // {
        //   isActive: selectFeature.referralpage ? (isTeamManager ? true : false) : false,
        //   icon: <GroupsRounded />,
        //   label: t("tab8_Team"),
        // },
        // {
        //   isActive: selectFeature.Tagcustomer ? true : false,
        //   icon: <PersonAddAlt />,
        //   label: t("tab_MyCustomers"),
        // },
        // {
        //   isActive: true,
        //   icon: <ReceiptRounded />,
        //   label: t("tab_YourSalesOrderDetails"),
        // },
        {
            index: 0,
            isActive: true,
            icon: _jsx(HomeIcon, {}),
            label: t("dashbord_Tab"),
            component: _jsx(Dashboard, {}),
        },
        {
            index: 1,
            isActive: selectFeature.CreateInvoice || selectFeature.CreateCheckout || selectFeature.CreateOrder,
            icon: _jsx(ShoppingCartRoundedIcon, {}),
            label: t("tab_CustomerInvoice"),
            component: _jsx(CustomerDetails, {}),
        },
        {
            index: 2,
            isActive: selectFeature.CreateB2BOrder,
            icon: b2bIcon,
            label: t("tab_CreateB2BOrder"),
            component: _jsx(B2bCustomerDetails, {}),
        },
        {
            index: 3,
            isActive: selectFeature.AffiliateLink,
            icon: ContactAndAffiliteLinkIcon,
            label: selectFeature.microsites ? (_jsxs("span", { children: [t("contact_Cart_Heading"), _jsx("br", {}), "& ", t("tab_AffiliateLink")] })) : (t("tab_AffiliateLink")),
            component: _jsx(AffiliateLinkContactCard, {}),
        },
        {
            index: 4,
            isActive: selectFeature.CartSharing,
            icon: cartSharingIcon,
            label: t("SharedCart"),
            component: _jsx(CartShare, {}),
        },
        {
            index: 5,
            isActive: selectFeature.CouponeCode || selectFeature.SalesrepCoupon,
            icon: DiscountCouponIcon,
            label: t("tab_DiscountCoupon"),
            component: _jsx(DiscountCoupon, {}),
        },
        {
            index: 6,
            isActive: selectFeature.referralpage ? (isTeamManager ? true : false) : false,
            icon: _jsx(GroupsRoundedIcon, {}),
            label: t("tab8_Team"),
            component: _jsx(Teams, {}),
        },
        {
            index: 7,
            isActive: (repData === null || repData === void 0 ? void 0 : repData.PlanType) === 9 && isTeamManager,
            icon: _jsx(LocationOnIcon, {}),
            label: t("tab_TerritoryReports"),
            component: _jsx(TerritoryReports, {}),
        },
        {
            index: 8,
            isActive: selectFeature.Tagcustomer,
            icon: _jsx(PersonIcon, {}),
            label: t("tab_MyCustomers"),
            component: _jsx(MyCustomer, {}),
        },
        {
            index: 9,
            isActive: additionaiFeatureB2BCompany,
            icon: _jsx(ApartmentIcon, {}),
            label: t("My_Company"),
            component: _jsx(MyCompany, {}),
        },
        {
            index: 10,
            isActive: true,
            icon: _jsx(ReceiptRoundedIcon, {}),
            label: t("tab_YourSalesOrderDetails"),
            component: _jsx(SalesOrderDetails, {}),
        },
    ];
}
